export enum RettighedsType {
  DeveloperMode = 'DeveloperMode',

  AppAdmin = 'AppAdmin',
  AdminBruger = 'AdminBruger',
  AdminRolle = 'AdminRolle',
  AdminLog = 'AdminLog',
  AdminSupportSletRevision = 'AdminSupportSletRevision',
  AdminSupportVendTilFysiskUnderskrift = 'AdminSupportVendTilFysiskUnderskrift',

  AdminPengeinstitutter = 'AdminPengeinstitutter',
  AdminPengeinstitutterSkriv = 'AdminPengeinstitutterSkriv',
  AdminPensionsudbydere = 'AdminPensionsudbydere',
  AdminPensionsudbydereSkriv = 'AdminPensionsudbydereSkriv',
  AdminRaadgivere = 'AdminRaadgivere',
  AdminRaadgivereSkriv = 'AdminRaadgivereSkriv',
  AdminDokumenter = 'AdminDokumenter',
  AdminKunder = 'AdminKunder',
  AdminOpkraevningslister = 'AdminOpkraevningslister',
  AdminOpkraevningslisterSkriv = 'AdminOpkraevningslisterSkriv',
  AdminProduktlister = 'AdminProduktlister',
  AdminRisikoopkraevning = 'AdminRisikoopkraevning',
  AdminRisikoopkraevningSkriv = 'AdminRisikoopkraevningSkriv',
  AdminBatch = 'AdminBatch',
  AdminBatchSkriv = 'AdminBatchSkriv',
  AdminDriftsmeddelelser = 'AdminDriftsmeddelelser',
  AdminSsbKonfiguration = 'AdminSsbKonfiguration',
  AdminSsbKonfigurationSkriv = 'AdminSsbKonfigurationSkriv',
  AdminFiler = 'AdminFiler',
  AdminFilerSlet = 'AdminFilerSlet',
  AdminFilerUpload = 'AdminFilerUpload',
  AdminManuelHelbred = 'AdminManuelHelbred',
  AdminLetpensionDk = 'AdminLetpensionDk',
  AdminLetregister = 'AdminLetregister',
  AdminLetregisterSkriv = 'AdminLetregisterSkriv',
}
